// extracted by mini-css-extract-plugin
export default {"zoomModal":"u5-z","image":"v5-z","button":"w5-z","isOverlayShown":"x5-z"};